import { deepClone } from 'paliari-js-utils'

export const vuexDefaultMapping = {
  getters: ['loading'],
  actions: ['fetchOne', 'fetchUpdate', 'fetchCreate', 'fetchRemove'],
}

export default {
  data() {
    return { current: null }
  },

  computed: {
    titlePrefix() {
      return this.isNew ? 'Criar ' : 'Alterar '
    },

    isNew() {
      return this.resourceId === 'new'
    },

    invalid() {
      return this.$v.$invalid
    },

    resourceId() {
      return this.$route.params.id
    },
  },

  methods: {
    beforeSave() {},

    async save() {
      try {
        this.beforeSave()
        const method = this.current.id ? 'fetchUpdate' : 'fetchCreate'
        return await this[method](this.current)
          .then(() => {
            this.$router.go(-1)
          })
          .catch(e => {
            if (e.errors && e.errors[0]) throw new Error(e.errors[0])
            throw e
          })
      } catch (e) {
        this.$toaster.error(e.message)
      }
    },
  },

  created() {
    if (this.isNew) {
      this.current = this.newModel({})
    } else {
      return this.fetchOne(this.resourceId).then(res => {
        this.current = this.newModel(deepClone(res))
      })
    }
  },
}
